/**
 * @generated SignedSource<<a0c722fcd8ec26d1f24b7b2c09cf98af>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "UpdateUserPayload",
            "kind": "LinkedField",
            "name": "updateUser",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfUser",
                    "kind": "LinkedField",
                    "name": "userEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "color",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SchedulableEntityColorRowUpdateUserMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SchedulableEntityColorRowUpdateUserMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "28739acae0ef63b7ae9849fbcd64ce22",
            "id": null,
            "metadata": {},
            "name": "SchedulableEntityColorRowUpdateUserMutation",
            "operationKind": "mutation",
            "text": "mutation SchedulableEntityColorRowUpdateUserMutation(\n  $model: UpdateUserRequestInput!\n) {\n  updateUser(model: $model) {\n    userEdge {\n      node {\n        id\n        color\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "496d84e96e33b6c7b5667e8c0aa6551a";
export default node;
